import { Box } from "@mui/material";

const InputWrapper = ({ children }: { children: any }) => {
  return (
    <Box
      sx={{
        border: "1px solid #E2E2E2",
        borderRadius: "8px",
        padding: "20px 15px",
        fontSize: "15px",
      }}
    >
      {children}
    </Box>
  );
};

export default InputWrapper;
